import { SVGProps } from 'react'

const SvgSensorEventStuckSpoon = (props: SVGProps<SVGSVGElement>) => (
  <svg fill='none' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M3.742 17.258a1.048 1.048 0 0 0 0 1.485l.03.028c.016.015.033.03.05.043.458.438 1.055.718 1.733.812.678.094 1.414 0 2.137-.274a5.8 5.8 0 0 0 2.02-1.322 5.8 5.8 0 0 0 1.322-2.019c.41-1.087.41-2.19 0-3.074l7.558-7.558a1.048 1.048 0 0 0 0-1.485 1.048 1.048 0 0 0-1.485 0L3.743 17.258z' />
  </svg>
)

export default SvgSensorEventStuckSpoon
